import React, { useState, useEffect } from "react";
import Aux from "../../../hoc/Auxilliary";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Grid,
  TablePagination,
} from "@material-ui/core/";
import { Link } from "react-router-dom";
import moment from "moment";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import localizedStrings from "../../../utils/localize";
import {
  getApplicantStatus,
  getApplicationProspectiveData,
  getOptionList,
} from "../../../reduxSlices/applicationSlice";
import {
  isObjectEmpty,
  applicationStatusOptionList,
} from "../../../utils/general";
import { formatDateInChicagoTimezone } from "../../../helpers/dateLogic";

const useStyles = makeStyles((theme) => ({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    flex: 1,
    lineHeight: 2,
  },

  bottomButtons: {
    paddingLeft: "24rem", // Default padding for large screens

    // Breakpoints for responsiveness
    [theme.breakpoints.down("md")]: {
      paddingLeft: "12rem",
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "7rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "2rem",
    },
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#005598",
    color: theme.palette.common.white,
    marginTop: "10px",
    verticalAlign: "top !important",
  },
  body: {
    padding: "1px 10px 26px",
    fontSize: 14,
    verticalAlign: "top !important",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const ApplicationHome = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles(props);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [prospectiveApplication, setProspectiveApplication] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const prospectiveData = useSelector(
    (state) => state.applicationData.applicationData,
  );

  const applicationprospectiveData = useSelector(
    (state) => state.applicationData.applicationprospectiveData,
  );

  const dataFetchingStatus = useSelector(
    (state) => state.selectClassData.dataFetchingStatus,
  );

  const errorMessage = useSelector(
    (state) => state.selectClassData.errorMessage,
  );

  const errorStatusCode = useSelector(
    (state) => state.selectClassData.errorStatusCode,
  );
  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const customLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to} ${localizedStrings.general.of} ${count}`;
  };

  useEffect(() => {
    dispatch(
      getApplicantStatus(window.localStorage.getItem("x-auth-contactId")),
    );
  }, [dispatch]);

  useEffect(() => {
    if (
      !isObjectEmpty(
        applicantStatus?.ses_applicantstatus &&
          applicantStatus?.ses_applicantstatus?.ses_applicantid,
      )
    ) {
      dispatch(
        getApplicationProspectiveData(
          applicantStatus?.ses_applicantstatus?.ses_applicantid,
        ),
      );
    }
  }, [applicantStatus]);

  const funcOptionList = (status) => {
    let value;
    if (optionList?.length !== 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
        return null;
      });
    }
    value = applicationStatusOptionList(value);
    return value;
  };

  useEffect(() => {
    const entity = "ses_application";
    const attributename = "ses_applicationstatus";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    if (prospectiveData.length === 0) setDisabled(true); // zero applications
    if (prospectiveData.length > 0) {
      const data = [...prospectiveData];
      data.sort(
        (item1, item2) => new Date(item2.createdon) - new Date(item1.createdon),
      );
      setProspectiveApplication(data);
      const allApplicationsStarted = data.every(
        (item) => item.ses_applicationstatus === 284210000,
      );
      setDisabled(allApplicationsStarted);
    }
  }, [prospectiveData]);

  const getStatusDescription = (status) => {
    const statusDescriptions = {
      284210000:
        "La demande a été commencée et sauvegardée, mais n’a pas encore été soumise.",
      284210001:
        "La demande a été soumise. L’équipe des admissions traitera la demande sous peu. Tu peux revenir dans quelques jours ouvrables pour consulter l’état de la demande.",
      284210002:
        "Ton dossier d’admission est complet et en cours d'évaluation. Une réponse à la demande sera disponible ici sur le portail dans le courant des prochaines semaines.",
      284210003:
        "Consulter l’état de la demande pour connaitre les actions que tu dois entreprendre pour compléter ton dossier d’admission.",
      284210004:
        "Ta candidature est jugée admissible selon les renseignements fournis à présent. Tu devras satisfaire à certaines conditions pour recevoir une admission officielle.",
      284210005:
        "Félicitations! Ta candidature est jugée admissible sans condition.",
      284210006:
        "Ta candidature est jugée admissible, mais le programme en question est complet. Si une place se libère, l’équipe des admissions te contactera.",
      284210007:
        "Tu as accepté ton offre d’admission. Nous avons hâte de te voir bientôt à l’USB!",
      284210011:
        "Tu as maintenant accès à ton adresse courriel @monusb, au portail étudiant complet et à eCampus. Tu peux procéder à l’inscription aux cours pendant la période prédéterminée.",
      284210012:
        "L’équipe des admissions de l’USB a annulé ta demande d’admission.",
      284210013: `Ta candidature est maintenant inactive pour une des raisons suivantes. <br/>
         • Tu as décidé de refuser ton offre d’admission, car tu n’as pas l’intention de poursuivre tes études à l’USB pour le moment.<br/>
         • Tu n’as pas répondu à ton offre d’admission par la date limite. <br/>
         • Tu as décidé de retirer ta candidature. <br/>
         • Tu n’as pas complété ton dossier d’admission par la date limite ou tu as complété ton dossier d’admission après la date limite.<br/>
         • Tu n’as pas soumis ta demande par la date limite. `,

      943240001: "Malheureusement, ta candidature n’a pas été acceptée.",
      943240002 :"Ton inscription est faite.",
      943240003 :"Ton offre d'admission n'est plus valide car il n'y a pas eu d'inscription.", //"Your offer of admission is no longer valid because there has been no registration."
    };

    return statusDescriptions[status] || null;
  };

  let tableData = "";

  if (prospectiveApplication.length > 0) {
    if (prospectiveApplication) {
      if (Array.isArray(prospectiveApplication)) {
        tableData =
          prospectiveApplication.length > 0
            ? prospectiveApplication.map((element, index) => {
                return (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {formatDateInChicagoTimezone(element.createdon)}
                    </StyledTableCell>
                    <StyledTableCell style={{ width: "50vh" }}>
                      {element.ses_certificationprogramname}
                    </StyledTableCell>
                    <StyledTableCell>
                      {
                        element[
                          "_ses_academicperiodid_value@OData.Community.Display.V1.FormattedValue"
                        ]
                      }
                    </StyledTableCell>
                    <StyledTableCell>
                      {element.usb_applicationdeadlinedate !== null
                        ? formatDateInChicagoTimezone(
                            element.usb_applicationdeadlinedate,
                          )
                        : ""}
                    </StyledTableCell>
                    <StyledTableCell>
                    {element.usb_applicationsubmitteddate !== null
                        ? formatDateInChicagoTimezone(element.usb_applicationsubmitteddate)
                        : ""}
                    </StyledTableCell>
                    <StyledTableCell>
               {element.ses_applicationstatus === 284210000 ? (
                        <Link
                          to={`/prospective/application/${element._ses_applicantid_value}/${element.ses_applicationid}`}
                        >
                          {funcOptionList(element.ses_applicationstatus)}
                        </Link>
                      ) : [
                          284210002, 284210003, 284210004, 284210005, 284210006,
                          284210007, 284210011, 943240001,943240002
                        ].includes(element.ses_applicationstatus) ? (
                        <Link
                          to={`/prospective/detail/${element._ses_applicantid_value}/${element.ses_applicationid}`}
                        >
                          {funcOptionList(element.ses_applicationstatus)}
                        </Link>
                      ) : [943240003].includes(element.ses_applicationstatus) ? (
                        <>
                          {funcOptionList(element.ses_applicationstatus)}
                      </>
                      )
                      : (
                        funcOptionList(element.ses_applicationstatus)
                      )}
                    </StyledTableCell>

                    <StyledTableCell>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: getStatusDescription(
                            element.ses_applicationstatus,
                          ),
                        }}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                );
              })
            : null;
      }
    }
  }

  return (
    <Aux>
      <Grid container justifyContent="center">
        <Grid item xs={10}>
          <Grid className={classes.classConatiner}>
            <Typography component="div" className={classes.classFont}>
              {localizedStrings.application.applicationhome}
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              Bienvenue à la section d'admission de ton portail MonUSB! <br />
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              Que tu souhaites déposer une demande d’admission pour la première
              fois, changer de programmes ou obtenir un deuxième diplôme, c’est
              ici que ton parcours débute. <br />
            </Typography>
            <Typography
              component="div"
              className={classes.classFont}
              style={{ fontSize: "1rem" }}
            >
              Pour entamer une demande d’admission, tu n’as qu’à cliquer sur le
              bouton « COMMENCER MA DEMANDE D’ADMISSION »
              <br />
              Une fois ta demande soumise, elle va apparaitre dans la case
              ci-dessous. Tu pourras ensuite consulter l’état de ta demande
              d’admission en cliquant sur le statut « État ».
              <Typography
                component="div"
                className={classes.classFont}
                style={{ fontSize: "1rem" }}
              >
                Si tu as des questions en lien avec ta demande d’admission,
                n’hésite pas à communiquer avec nous par courriel à l’adresse{" "}
                <a href="mailto:admissions@ustboniface.ca">
                  admissions@ustboniface.ca
                </a>
                .
              </Typography>
              <Typography
                component="div"
                className={classes.classFont}
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                À noter : Si tu as déjà commencé une demande d’admission sans
                l’avoir soumise, clique sur le lien « Commencée » ci-dessous
                pour continuer ta demande au lieu d’en créer une nouvelle.
              </Typography>
            </Typography>
          </Grid>
          <TableContainer
            component={Paper}
            style={{ minHeight: "40vh", marginBottom: "10px" }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {localizedStrings.application.creationdate}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.program}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.yearandterm}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.deadline}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.submissiondate}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.status}{" "}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.application.statusdescription}{" "}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableData}</TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={
                prospectiveApplication.length > 0
                  ? prospectiveApplication.length
                  : 0
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              labelRowsPerPage={
                <span style={{ textTransform: "none" }}>
                  {localizedStrings.rows.rowsperpage}
                </span>
              }
              labelDisplayedRows={customLabelDisplayedRows}
            />
          </TableContainer>

          <Grid
            container
            justifyContent="center"
            spacing={2}
            className={classes.bottomButtons}
          >
            <Grid item>
              <Link to="/prospective/application">
                <Button variant="contained" color="primary">
                  {localizedStrings.application.applynow}
                </Button>
              </Link>
            </Grid>
            <Grid item>
              {!disabled ? (
                <Link to="/prospective/profile">
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={disabled}
                  >
                    {localizedStrings.application.viewprofile}
                  </Button>
                </Link>
              ) : (
                <Button variant="contained" color="primary" disabled={disabled}>
                  {localizedStrings.application.viewprofile}
                </Button>
              )}
            </Grid>
          </Grid>
          <br />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default ApplicationHome;
